module.exports = new __parcel__URL__("config-modal-illustration.34ff6920.svg").toString();